
export class GrievenceRedressalModel {
      redressalId:string;
      companyId: string;
      address: string;
      debtorCompany: string;
      debtorCompanyAddress:string;
      
      
      invoiceData:{
        invoiceAmount: string;
        paidDate: string;
        dueDate: string;
        invoiceNumber: string;
        invoice: any;
        currency: string;
        status: string;
        subject: string;
        //bankId: string;

      }[];
      currencyData: {
        currency: string;
        unpaidAmount: string;
      }[];
      networkData: {
        networkMembership: string;
        contactPerson: string;
        personEmail: string;
      }[];

      communication: {}[];
      accountStatement: {}[];
      shippingDocument: {}[];
      deliveryReceipt: {}[];
      addentialRevelentDocoument: {}[];

      claimForm: string;
      lastDate: string;
      formContact: string;
      protectionSystem: string;
      additionalNotes: string;
      formDeclare: boolean;
      termAndCondition: boolean;
  
      constructor() {
        this.redressalId = "";
        this.companyId = "";
        this.address = "";
        this.debtorCompany = "";
        this.debtorCompanyAddress="";
        this.invoiceData=[{
          invoiceAmount: "",
          paidDate: "",
          dueDate: "",
          invoiceNumber: "",
          invoice: null,
          currency: "",
          subject: "",
          status: "",
         // bankId: ""
        }];
    
        this.currencyData = [{
          currency: "",
          unpaidAmount: ""
        }];
        this.networkData= [{
          networkMembership: "",
          contactPerson: "",
          personEmail: ""
        }];
      
        this.communication= [{}];
        this.accountStatement = [{}];
        this.shippingDocument = [{}];
        this.deliveryReceipt = [{}];
        this.addentialRevelentDocoument = [{}];
    
        this.claimForm = "";
        this.lastDate = "";
        this.formContact = "";   
        this.protectionSystem= "No";    
        this.additionalNotes = "";
        this.termAndCondition = false;
        this.formDeclare=false;
      }
    
    }
    